// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Labels_wrapper__3VCH4","left":"Labels_left__Q7IV0","center":"Labels_center__3NfJA"};